module.exports = __webpack_public_path__ + "static/media/retailA2.0a936d92.png";